define('views/modules/calendar/calendar-item-menu-action',[
    'underscore', 'backbone', 'utils', 'mustache',
    // services
    'services/api',
    'services/i18n',
    'services/toastr-service',
    // models
    'models/parts/menu/save-button',
    'models/parts/menu/done-button',
    'models/parts/menu/datepicker',
    // parent view
    'views/parts/menu/menu-action',
], function(
    _, Backbone, U, Mustache,
    // services
    API,
    i18n,
    ToastrService,
    // models
    MSaveButton,
    MDoneButton,
    MDatePicker,
    // parent view
    VMenuAction
) {

    var VCalendarItemMenuAction = VMenuAction.extend({

        regions: {
            done: '.btn-action-done',
        },

        initialize: function(options) {
            this.options = options || {};
            this.collection = new Backbone.Collection([]);
            this.item = options.item;

            if (options.actionButton) {
                this.collection.add(options.actionButton);
            }

            if (options.onSave) {
                var saveItem = this.saveItem = new MSaveButton({
                    title: i18n.t("messages:tooltip-save-button"),
                    content: i18n.t("general:Save"),
                    callback: options.onSave
                 });
                 this.collection.add(saveItem);
            }

            this.doneItem = new MDoneButton(_.extend({
                    title: i18n.t('messages:tooltip-mark-as-done'),
                    context: this,
                    onDone: options.onDone,
                    callback: this.onDoneClick
            }, options.save)),

            this.dateItem = new MDatePicker({
                    title: i18n.t('messages:tooltip-activity-date'),
                    model: this.item
            });

            this.collection.add([this.doneItem]);

            this.listenTo(this.item, {
                'change:done': this.onItemDoneChange,
                'change:feedback_level': this.onItemFeedbackLevelChange,
            });

            VCalendarItemMenuAction.__super__.initialize.call(this, options);
        },

        render: function() {
            VCalendarItemMenuAction.__super__.render.apply(this, arguments);

            this.generateZones()
                .toggleDoneClass()
                .toggleFeedbackLevelClass();
        },

        toggleSaveButton: function(val) {
            this.saveItem.set('disabled', val);
            return this;
        },

        toggleDoneClass: function(value) {
            this.zone.$done.toggleClass('completed', value || this.item.get('done'));
            return this;
        },

        toggleFeedbackLevelClass: function(level) {
            var item = this.item,
                zone = this.zone.$done;
            zone.removeClassPrefix('level-');
            zone.addClass(Mustache.render('level-{{feedback_level}}', Mustache.getContext({
                feedback_level: level || this.item.get('feedback_level')
            })));
            return this;
        },
        ////////////
        // events //
        ////////////

        onDoneClick: function() {
            var item = this.item;
            if (!item.hasPassed()) {
                ToastrService.error('calendar:cannot-mark-future-items-as-done');
                return;
            }

            _.callback(this.options.context, this.doneItem.get('onDone'));
        },

        onItemDoneChange: function(model, value) {
            if (this.zone) {
                this.toggleFeedbackLevelClass(model.get('feedback_level') || 10);
                this.toggleDoneClass(value);
            }
        },

        onItemFeedbackLevelChange: function(model, value) {
            if (this.zone) {
                this.toggleFeedbackLevelClass(value);
            }
        },

    });

    return VCalendarItemMenuAction;
});

